module.exports = __webpack_public_path__ + "img/830.b8fbc35e.png";